var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":_vm.color(_vm.status),"outlined":_vm.status == 'Przyjęte' && (_vm.role == 'administrator' || _vm.role == 'moderator') 
        || _vm.status == 'Do sprawdzenia' && (_vm.role == 'administrator' || _vm.role == 'moderator') 
        || _vm.status == 'Do poprawki' && (_vm.role == 'administrator' || _vm.role == 'moderator') || _vm.role == 'korektor' && _vm.status == 'Oczekujące',"text-color":_vm.fontColor(_vm.status)}},[_vm._v(" "+_vm._s(_vm.status)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }